import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";
import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { bannerService, beneficaryServices } from "@/services/api/cresivoxServer";

import { iBeneficiaryDTO,REDUCER_NAME} from "./Types";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

export const addBeneficiary = createAsyncThunk<
iGenericResponse<any | null> | null,
{data:iBeneficiaryDTO},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("addBeneficiary"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({data}, {rejectWithValue}) => {
    try {
        const response = await beneficaryServices.createBeneficary(data);
        if (response) {
            const {httpStatusCode, data, message} = response;

            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                orders: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);

  export const getAllBeneficiaryList = createAsyncThunk<
  iGenericResponse<any | null> | null,
void,
  {
      rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("BeneficiaryList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (arg, {rejectWithValue}) => {
      try {
          const response = await beneficaryServices.getAllBeneficary();
          if (response) {
              const {httpStatusCode, data, message} = response;

              switch (httpStatusCode) {
                  case httpStatusCodes.SUCCESS_OK: {
                      if (data && data.data) {
                          return {
                            data:{
                                httpStatusCode,
                              data: data.data,
                              message,
                            }
                              
                          };
                      } else {
                          return rejectWithValue({
                              httpStatusCode,
                              message,
                          });
                      }
                  }
                  default: {
                      return rejectWithValue({
                          httpStatusCode,
                          message,
                      });
                  }
              }
          } else {
              return rejectWithValue({
                  message: "No response received",
              });
          }
      } catch (error) {
          return rejectWithValue({
              message: "Something went wrong",
          });
      }
  },
);



export const updateBeneficiary = createAsyncThunk<
iGenericResponse<any | null> | null,
{data:iBeneficiaryDTO,beneficiaryId:string},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateBeneficiary"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({data,beneficiaryId}, {rejectWithValue}) => {
    try {
        const response = await beneficaryServices.updateBeneficary(beneficiaryId,data);
        if (response) {
            const {httpStatusCode, data, message} = response;

            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                orders: data.data?.order,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);

export const deleteBeneficiary = createAsyncThunk<
iGenericResponse<any | null> | null,
{beneficiaryId:string},
{
    rejectValue: iStateMessage;
}
>(
curriedGetThunkName("deleteBeneficiary"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({beneficiaryId}, {rejectWithValue}) => {
    try {
        const response = await beneficaryServices.deleteBeneficary(beneficiaryId); // ✅ Ensure correct structure
        if (response) {
            const {httpStatusCode, data, message} = response;
            switch (httpStatusCode) {
                case httpStatusCodes.SUCCESS_OK: {
                    if (data && data.data) {
                        return {
                            data: {
                                data: data.data,
                                message,
                            }
                        };
                    } else {
                        return rejectWithValue({
                            httpStatusCode,
                            message,
                        });
                    }
                }
                default: {
                    return rejectWithValue({
                        httpStatusCode,
                        message,
                    });
                }
            }
        } else {
            return rejectWithValue({
                message: "No response received",
            });
        }
    } catch (error) {
        return rejectWithValue({
            message: "Something went wrong",
        });
    }
},
);


